import { makeStyles } from '@material-ui/core/styles'
import {
  coachProfileBandOuter,
  coachProfileContentCanvas,
} from '@lib/pga-coach/coach-profile-layout'

const useStyles = makeStyles((theme) => ({
  /**
   * Full-bleed white band for isolated / Storybook use. Product
   * placement is the in-bio Accreditations list (`rootEmbedded`).
   */
  root: ({ inColumn }) => ({
    backgroundColor: theme.palette.common.white,
    ...coachProfileBandOuter(theme, {
      inColumn,
      fullBleed: !inColumn,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      md: {
        paddingTop: theme.spacing(2.5),
        paddingBottom: theme.spacing(2.5),
      },
    }),
  }),
  rootEmbedded: {
    /**
     * In-bio About placement, sibling to Tools & Technology — no
     * viewport breakout, no top border. Top margin is owned by the
     * CoachBio two-column wrapper when both lists render.
     */
    marginTop: theme.spacing(2),
    borderRadius: 0,
    backgroundColor: 'transparent',
    ...coachProfileBandOuter(theme, {
      inColumn: true,
      fullBleed: false,
      paddingTop: 0,
      paddingBottom: theme.spacing(0.5),
      md: {
        paddingTop: 0,
        paddingBottom: theme.spacing(0.5),
      },
    }),
  },
  inner: ({ inColumn }) => ({
    ...coachProfileContentCanvas({ inColumn }),
    display: 'flex',
    flexDirection: 'column',
    alignItems: inColumn ? 'flex-start' : 'center',
    gap: theme.spacing(1.25),
  }),
  innerEmbedded: {
    ...coachProfileContentCanvas({ inColumn: true }),
    alignItems: 'flex-start',
    gap: 0,
  },
  /**
   * Bold PGA Accreditations header — same `subtitle1` / `h3` pairing as
   * Tools & Technology (`CoachToolsRow`).
   */
  heading: {
    margin: 0,
    marginBottom: theme.spacing(1),
    color: theme.palette.secondary.dark,
    fontWeight: 700,
  },
  list: ({ embedded }) => ({
    margin: 0,
    paddingLeft: embedded ? 0 : theme.spacing(2.5),
    listStyleType: embedded ? 'none' : 'disc',
    width: '100%',
  }),
  item: ({ embedded }) => ({
    color: theme.palette.secondary.main,
    marginBottom: embedded ? theme.spacing(1.25) : theme.spacing(0.5),
    '&:last-child': {
      marginBottom: 0,
    },
  }),
  /**
   * Underlined label that opens the shared accreditation explainer.
   * Real `<button>` (one control per bullet) — not nested in a link.
   * Matches the adjacent details location links while preserving the
   * button semantics needed for the explainer dialog.
   */
  itemButton: {
    appearance: 'none',
    background: 'transparent',
    border: 0,
    padding: 0,
    margin: 0,
    display: 'inline',
    color: theme.palette.blue.main,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 600,
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    textAlign: 'left',
    textTransform: 'none',
    textDecoration: 'underline',
    textUnderlineOffset: 3,
    cursor: 'pointer',
    '&:hover, &:focus-visible': {
      color: theme.palette.secondary.light,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.blue.main}`,
      outlineOffset: 2,
    },
  },
}))

export default useStyles
